import { createSlice } from "@reduxjs/toolkit";

interface ThemeState {
  darkMode: boolean;
}

// detect the user's browser preference
const getInitialTheme = () => {
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark;
};

const initialState: ThemeState = {
  darkMode: getInitialTheme(),
};

// apply the theme on initialization
const element = document.documentElement;
if (initialState.darkMode) {
  element.classList.add("dark");
} else {
  element.classList.remove("dark");
}

const themeSlice = createSlice({
  name: "darkMode",
  initialState,
  reducers: {
    // Action to set dark mode directly
    setDarkMode(state, action) {
      state.darkMode = action.payload;
      localStorage.setItem("darkMode", JSON.stringify(state.darkMode));
      const element = document.documentElement;
      if (state.darkMode) {
        element.classList.add("dark");
      } else {
        element.classList.remove("dark");
      }
    },
    toggleTheme(state) {
      state.darkMode = !state.darkMode;
      localStorage.setItem("darkMode", JSON.stringify(state.darkMode));
      const element = document.documentElement;
      if (state.darkMode) {
        element.classList.add("dark");
      } else {
        element.classList.remove("dark");
      }
    },
  },
});

// Export actions
export const { toggleTheme, setDarkMode } = themeSlice.actions;
// Export reducer
export default themeSlice.reducer;
